import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { UnifiedRoutingContactOwnerPreview } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingContactOwnerPreview';
import { UnifiedRoutingUsersAndTeamsPreview } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingUsersAndTeamsPreview';
import { checkIsUnassigned, getRoutingRules } from 'automation-ui-action-features/actions/rotate-object/utils/routing-rules';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { checkCanHaveFallback } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnifiedRoutingActionPreview = ({
  actionMetadata,
  objectTypeId
}) => {
  const routingRuleDefinition = getRoutingRules(actionMetadata);
  if (checkIsUnassigned(routingRuleDefinition)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ObjectTypeName
      },
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.no-one_jsx",
      options: {
        objectTypeId
      }
    });
  }
  const PreviewComponent = checkCanHaveFallback(routingRuleDefinition) ? UnifiedRoutingContactOwnerPreview : UnifiedRoutingUsersAndTeamsPreview;
  return /*#__PURE__*/_jsx(PreviewComponent, {
    routingRuleDefinition: routingRuleDefinition,
    objectTypeId: objectTypeId
  });
};
UnifiedRoutingActionPreview.displayName = 'UnifiedRoutingActionPreview';